<template>
    <section class="padding-vertical-content mb-3 mb-lg-4 row">
        <div class="px-2">
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <div class="row mb-5">
                    <div class="col-md-4 col-12">
                        <FormInput style="width: 96%; margin: auto" label="Nombre" type="text" name="nombre" id="nombre" rules="required" v-model="base_data.nombre" :disabled="!paso_activo" />
                    </div>
                    <div class="col-md-4 col-12 mt-md-0 mt-3">
                        <FormInput style="width: 96%; margin: auto" label="Apellidos" type="text" name="apellidos" id="apellidos" rules="required" v-model="base_data.apellidos" :disabled="!paso_activo" />
                    </div>
                    <div class="col-md-4 col-12 mt-md-0 mt-3">
                        <ValidationProvider name="tipo de documento" rules="required" v-slot="{ errors }">
                            <div class="form-group" style="width: 96%; margin: auto">
                                <label>{{ $t('formularios.tipo_identificacion') }}</label>
                                <multiselect
                                    v-model="tipoDocumentoSeleccionado"
                                    label="label"
                                    track-by="type"
                                    class="custom-multiselect mt-4"
                                    :class="(errors[0] ? 'is-invalid' : '')"
                                    id="tipo-documento"
                                    placeholder="Seleccione tipo de documento"
                                    :options="tiposDocumento"
                                    @input="onSeleccionTipoDocumento"
                                    :disabled="!paso_activo"
                                />
                                <span v-if="errors[0]" class="invalid-feedback text-xs" style="display: block;">
                                    {{ errors[0] }}
                                </span>
                            </div>
                        </ValidationProvider>
                    </div>

                    <div class="col-md-4 col-12 mt-3">
                        <div class="form-group" style="width: 96%; margin: auto">
                            <label>{{ texto_documentacion }} *</label>
                            <ValidationProvider
                                :name="texto_documentacion"
                                :rules="{ required: true, identificacion: { tipo: tipoDocumentoSeleccionado?.type } }"
                                v-slot="{ errors }"
                            >
                                <input
                                    v-model="base_data.dni"
                                    type="text"
                                    id="dni"
                                    :disabled="!paso_activo || !tipoDocumentoSeleccionado"
                                    :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                    :placeholder="texto_documentacion"
                                />
                                <span
                                    v-if="errors[0]"
                                    class="invalid-feedback text-xs error-message"
                                    style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                                >
                                    <b>{{ errors[0] }}</b>
                                </span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-md-4 col-12 mt-3">
                        <FormInput style="width: 96%; margin: auto" label="Fecha de nacimiento" type="date" max="9999-12-31" name="fecha nacimiento" id="fecha_nacimiento" rules="required" v-model="base_data.fecha_nacimiento" :disabled="!paso_activo" />
                    </div>
                    <div class="col-md-4 col-12 mt-3">
                        <FormInput style="width: 96%; margin: auto" label="Fecha de caducidad del DNI" type="date" max="9999-12-31" name="fecha de caducidad dni" id="fecha_caducidad_dni" rules="required" v-model="base_data.fecha_caducidad_dni" :disabled="!paso_activo" />
                    </div>

                    <div class="col-md-4 col-12 mt-3">
                        <div class="form-group" style="width: 96%; margin: auto">
                            <label>Teléfono *</label>
                            <PhoneInput
                                name="telefono"
                                data-cy="telefono"
                                :phone="base_data.telefono ?? null"
                                :desactivar="!paso_activo"
                                :required="true"
                                :error_telefono="error_telefono"
                                id="telefono"
                                @setNumber="(number) => base_data.telefono = number"
                                @validNumber="(valid) => telefono_valido = valid"
                                @onTyping="(phone) => {
                                    if (phone && phone.length > 0) {
                                        error_telefono = 0;
                                    }
                                }"
                            />
                            <span
                                v-if="error_telefono"
                                class="invalid-feedback text-xs error-message mt-3"
                                style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                            >
                                <b>El teléfono es requerido y debe ser válido</b>
                            </span>
                        </div>
                    </div>
                    <div class="col-md-4 col-12 mt-3">
                        <FormInput style="width: 96%; margin: auto" label="Email" type="email" name="email" id="email" rules="required" v-model="base_data.email" :disabled="!paso_activo" />
                    </div>
                    <div class="col-md-4 col-12 mt-3">
                        <Paises
                            id="pais_de_nacimiento"
                            :desactivar="!paso_activo ? true : false"
                            :errors="errors"
                            class="mt-3"
                            @rellenarPais="rellenarPais"
                            style="width: 96%; margin: auto"
                            v-on:selected="
                                (opt) => {
                                    pais = opt;
                                    base_data.pais_de_nacimiento = opt;
                                }
                            "
                        />
                    </div>

                    <div class="col-md-4 col-12 mt-3">
                        <Provincias
                            id="provincia_de_nacimiento"
                            :desactivar="!paso_activo ? true : false"
                            :errors="errors"
                            style="width: 96%; margin: auto"
                            :pais="pais.id"
                            class="mt-3"
                            :provincia="provincia"
                            v-on:selected="
                                (opt) => {
                                    provincia = opt;
                                    base_data.provincia_nacimiento_id = opt.id;
                                }
                            "
                        />
                    </div>
                    <div class="col-md-4 col-12 mt-3">
                        <Locations
                            style="width: 96%; margin: auto"
                            id="localidad_de_nacimiento"
                            :desactivar="!paso_activo ? true : false"
                            :provincia="provincia"
                            class="mt-3"
                            :location_id="Number(base_data.localidad_nacimiento_id)"
                            :errors="errors"
                            v-on:selected="
                                (opt) => {
                                    base_data.localidad_nacimiento_id = opt.id;
                                }
                            "
                        />
                    </div>
                    <div class="col-md-4 col-12 mt-3">
                        <FormInput style="width: 96%; margin: auto" label="Nacionalidad" type="text" name="nacionalidad" id="nacionalidad" rules="required" v-model="base_data.nacionalidad" :disabled="!paso_activo" />
                    </div>

                    <div class="col-md-4 col-12 mt-3">
                        <FormInput style="width: 96%; margin: auto" label="Dirección" type="text" name="direccion" id="direccion" rules="required" v-model="base_data.direccion" :disabled="!paso_activo" />
                    </div>
                    <div class="col-md-4 col-12 mt-3">
                        <FormInput style="width: 96%; margin: auto" label="Club de procedencia (Si aplica)" type="text" name="club_de_procedencia" id="club_de_procedencia" rules="" v-model="base_data.club_de_procedencia" :disabled="!paso_activo" />
                    </div>
                    <div class="col-md-4 col-12 mt-3">
                        <label class="mb-2" style="margin-left: 2%; font-size: 0.9rem;">CATEGORÍA BASE</label>
                        <ValidationProvider name="categoría base" id="categoria_base" rules="required" v-slot="{ errors }">
                            <multiselect
                                :disabled="!paso_activo"
                                v-model="base_data.categoria_base"
                                id="categoria"
                                placeholder="Categoría Base"
                                :class="'w-100' + (errors[0] ? ' is-invalid' : '')"
                                style="width: 96%; margin: auto; margin-top: 1.2rem;"
                                label="name"
                                track-by="id"
                                :multiple="false"
                                :options="categorias_bases"
                                v-on:select="(selectedOpt) => $emit('selected', selectedOpt)"
                            >
                                <template slot="option" slot-scope="props">
                                    <div class="option__desc"><span class="option__title">{{ props.option.name }}</span> - <span class="option__small">{{ props.option.precio | formatear_precio }}</span></div>
                                </template>
                            </multiselect>
                            <span
                                v-if="errors[0]"
                                class="invalid-feedback text-xs error-message"
                                style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                            >
                                <b>{{ errors[0] }}</b>
                            </span>
                        </ValidationProvider>
                    </div>

                    <div class="col-md-4 col-12 mt-3" v-if="equipos">
                        <label class="mb-2" style="margin-left: 2%; font-size: 0.9rem;">EQUIPOS</label>
                        <ValidationProvider name="equipo" id="equipo" rules="required" v-slot="{ errors }">
                            <multiselect
                                :disabled="!paso_activo"
                                v-model="base_data.equipo"
                                id="equipo"
                                placeholder="Equipo"
                                :class="errors[0] ? ' is-invalid' : ''"
                                style="width: 96%; margin-left: 1rem;"
                                label="nombre"
                                track-by="id"
                                :options="equipos"
                            />
                            <span
                                v-if="errors[0]"
                                class="invalid-feedback text-xs error-message"
                                style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                            >
                                <b>{{ errors[0] }}</b>
                            </span>
                        </ValidationProvider>
                    </div>
                    <div :class="equipos ? 'col-md-4 col-12 mt-3' : 'col-md-4 col-12 mt-3 offset-md-4'">
                        <label class="mb-2" style="margin-left: 2%; font-size: 0.9rem;">LATERALIDAD</label>
                        <ValidationProvider name="lateralidad" id="lateralidad" rules="required" v-slot="{ errors }">
                            <multiselect
                                :disabled="!paso_activo"
                                v-model="base_data.lateralidad"
                                id="lateralidad"
                                placeholder="Lateralidad"
                                :class="'w-100' + (errors[0] ? ' is-invalid' : '')"
                                style="width: 96%; margin: auto"
                                :multiple="false"
                                :options="lateralidades"
                            />
                            <span
                                v-if="errors[0]"
                                class="invalid-feedback text-xs error-message"
                                style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                            >
                                <b>{{ errors[0] }}</b>
                            </span>
                        </ValidationProvider>
                    </div>

                    <div class="col-12 text-right mt-4">
                        <button v-if="active" type="button" @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" id="volver-paso-1" :disabled="!paso_activo">
                            <span>{{ $t('formularios.atras') }}</span>
                        </button>
                        <button type="submit" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar-paso-1" :disabled="!paso_activo">
                            <span>{{ $t('formularios.continuar') }}</span>
                        </button>
                    </div>
                </div>
            </ValidationObserver>
        </div>
    </section>

</template>

<script>
    import Provincias from "../../../common/forms/Provincias.vue";
    import Locations from "../../../common/forms/Locations.vue";
    import Paises from "../../../common/forms/Paises.vue";
    import PhoneInput from '@/components/common/PhoneInput';

    export default {
        props: {
            base: {
                type: Object,
                required: true
            },
            esMovil: {
                type: Boolean,
                default: false
            },
            paso_activo: {
                type: Boolean,
                default: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                errors: [],
                error: this.$route.query.error,
                provincia: null,
                pais: { id: 0 },
                nacionalidad: "Española",
                selected: null,
                items: null,
                categorias_bases: [],
                equipos: null,
                lateralidades: ['Diestro', 'Zurdo', 'Ambidiestro'],
                fields_deportista : {},
                base_data : { ...this.base },
                error_telefono: 0,
                telefono_valido: false,
                tipoDocumentoSeleccionado: null,
                texto_documentacion: 'Seleccione el tipo de documento',
                tiposDocumento: [
                    { type: 'DNI', label: 'DNI' },
                    { type: 'NIE', label: 'NIE' },
                    { type: 'NIF', label: 'NIF' },
                    { type: 'PASSPORT', label: 'PASAPORTE' }
                ]
            };
        },
        created() {
            this.base_data.lista_id = this.lista_id;
            this.tipoDocumentoSeleccionado  = this.tiposDocumento.find(tipo => tipo.type === 'DNI');
            this.setTextoDocumentacion();

            this.$store.dispatch(this.config.getVuexAlias("back.bases.categorias.precios"), this.base_data).then(res => {
                this.categorias_bases = res.data.data;
                if (this.categorias_bases && this.categorias_bases.length == 1) {
                    this.base_data.categoria_base = this.categorias_bases[0];
                }
            });

            this.getEquipos();

            if (!this.base_data.provincia_de_nacimiento) {
                this.provincia = this.teatro.provincia;
            }

            if (!this.base_data.pais_de_nacimiento) {
                this.base_data.pais_de_nacimiento = {
                    id: 68,
                    iso3: "ESP",
                    nombre: "España",
                }
                this.base_data.pais_nacimiento_id = this.base_data.pais_de_nacimiento?.id;
            }
        },
        methods: {
            rellenarPais(pais) {
                this.base_data.pais_de_nacimiento = pais;
                this.pais = pais;
            },
            terminar() {
                let base = this.base_data;

                base.categoria_base_id = base.categoria_base?.id;
                base.equipo_id = base.equipo?.id;
                base.taquilla = true;

                base.fields_deportista = Object.keys(this.fields_deportista).map(key => ({
                    name: key,
                    value: this.fields_deportista[key],
                }));


                let params = {
                    lista_id: this.lista_id,
                    base: base,
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.guardar-datos'), params).then(res => {
                    this.base_data.categoria_base.session_id = res.data.session_id;
                });

                this.base_data.fields_deportista = Object.keys(this.fields_deportista).map(key => {
                    return {
                        name: key,
                        value: this.fields_deportista[key]
                    };
                });
                this.$emit("guardarBase", this.base_data);

                this.$emit("terminado");
            },
            getEquipos() {
                var params = {
                    lista_id: this.lista_id,
                    filters: {}
                };

                this.$store.dispatch(this.config.getVuexAlias("back.bases.equipos.index"), params).then(res => {
                    this.equipos = res.data.data;
                });
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                const telefono_es_valido = this.telefono_valido && this.base_data.telefono;

                if (isValid && telefono_es_valido) {
                    this.error_telefono = 0;
                    this.terminar();
                } else if (!telefono_es_valido) {
                    this.error_telefono = 1;
                }
            },
            volver() {
                this.$emit("guardarBase", this.base_data);
                this.$emit('volver');
            },
            onSeleccionTipoDocumento(option) {
                this.tipoDocumentoSeleccionado = option;
                this.setTextoDocumentacion();
                this.base_data.dni = '';
            },
            setTextoDocumentacion() {
                switch (this.tipoDocumentoSeleccionado?.type) {
                    case 'DNI':
                        this.texto_documentacion = 'DNI';
                        break;
                    case 'NIE':
                        this.texto_documentacion = 'NIE';
                        break;
                    case 'NIF':
                        this.texto_documentacion = 'NIF';
                        break;
                    case 'PASSPORT':
                        this.texto_documentacion = 'Pasaporte';
                        break;
                    default:
                        this.texto_documentacion = 'Seleccione el tipo de documento';
                        break;
                }
            },
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_id() {
                return this.$route.params.lista_id;
            },
            fields() {
                return this.$store.getters.getListaAbonados.basesFields.filter(field => field.deportista === true);
            }
        },
        components: { Paises, Locations, Provincias, PhoneInput },
    };
</script>

<style scoped>
    @media (max-width: 992px) {
        #localidad_de_nacimiento {
            width: 92.6%;
        }

        #categoria {
            width: 60%;
        }

        .multiselect {
            width: 98%;
        }
    }

    @media (max-width: 768px) {
        .multiselect {
            width: 100% !important;
            margin-left: 0 !important;
        }

        label.ml-4 {
            margin-left: 1rem !important;
            padding-left: 0 !important;
        }


        .invalid-feedback {
            margin-left: 0.5rem !important;
            width: 95% !important;
        }
    }

</style>
